<template>
  <b-row>
    <b-col
      md="8"
      lg="8"
      offset-lg="2"
    >
      <b-card
        no-body
        class="card-payment"
      >
        <b-card-body>
          <!-- form -->
          <b-form>
            <validation-observer
              ref="settingsform"
              tag="form"
            >
              <b-row>
                <b-col sm="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Payment Method"
                    rules="required"
                  >
                    <b-form-group
                      label="Payment Method"
                      label-for="payment_method"
                    >
                      <v-select
                        id="payment_method"
                        v-model="selectedPaymentMethod"
                        :options="paymentMethodOptions"
                        label="payment_method_title"
                        persistent-hint
                        return-object
                        single-line
                      />
                      <!--<v-select
                        id="payment_method"
                        :options="paymentMethodOptions"
                        label="payment_method_title"
                        :value="paymentMethodId"
                        @input="setSelected"
                        persistent-hint
                        return-object
                        single-line
                      />-->
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                    label="Max. Interest Free Months"
                    label-for="max_interest_free_months"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Max. Interest Free Months"
                      rules="required|validatorFloat"
                    >
                      <b-input-group append="Month(s)">
                        <b-form-input
                          id="max_interest_free_months "
                          v-model="setting_values.plan_max_interest_months"
                          type="number"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                    label="Min Allowed Amount"
                    label-for="min_allowed_amount"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Min Allowed Amount"
                      rules="required|minmonths|validatorFloat"
                    >
                      <b-input-group append="kr.">
                        <b-form-input
                          id="min_allowed_amount"
                          v-model="setting_values.plan_min_amount"
                          type="number"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                    label="Max Allowed Months"
                    label-for="max_allowed_months"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Max. Allowed Months"
                      rules="required|minmonths|validatorFloat"
                    >
                      <b-input-group append="Month(s)">
                        <b-form-input
                          id="max_allowed_months "
                          v-model="setting_values.plan_max_months"
                          type="number"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="6"
                  offset-lg="3"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    variant="primary"
                    @click="postSettingValues"
                  >
                    Save
                  </b-button>
                </b-col>
              </b-row>
            </validation-observer>
          </b-form>
          <!--/ form -->
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BFormInput, BButton, BForm, BInputGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, minmonths, validatorFloat } from '@validations'
import axios from '@axios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
    BInputGroup,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      setting_values: {
        plan_payment_method: '',
        plan_min_amount: '',
        plan_max_months: '',
        plan_max_interest_months: '',
      },
      selectedPaymentMethod: '',
      paymentMethodOptions: [],
      paymentMethodId: '',
      required,
      minmonths,
      validatorFloat,
    }
  },
  created() {
    this.getPaymentMethods()
    this.getSettingValues()
  },
  methods: {
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    getSettingValues() {
      axios.get('settings/get_setting_values').then(response => {
        const settingValues = this.setting_values
        const data = response.data.values
        this.paymentMethodId = data.plan_payment_method.value
        for (const [key, value] of Object.entries(this.paymentMethodOptions)) {
          console.log(`${key}: ${value}`)
          console.log(value.id)
          console.log(this.paymentMethodId)
          if (parseInt(value.id, 10) === parseInt(this.paymentMethodId, 10)) {
            this.selectedPaymentMethod = value.payment_method_title
          }
        }
        settingValues.plan_min_amount = data.plan_min_amount.value
        settingValues.plan_max_months = data.plan_max_months.value
        settingValues.plan_max_interest_months = data.plan_max_interest_months.value
      })
    },
    getPaymentMethods() {
      axios.get('settings/get_payment_methods').then(response => {
        console.log('methods ', response.data.methods)
        this.paymentMethodOptions = response.data.methods
      })
    },
    postSettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            console.log(this.setting_values)
            console.log(this.selectedPaymentMethod)
            this.setting_values.plan_payment_method = this.selectedPaymentMethod.id
            axios.post('settings/put_setting_values', { ...this.setting_values }).then(response => {
              console.log(response)
              this.makeSuccessToast()
              resolve(true)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
